import React, { Suspense } from "react";

import classNames from "classnames";

import Loading from "components/Loading";

const LazySQLView = React.lazy(() => import("./index.lazy"));

const SQLView = ({
  sql,
  placeholder,
  className,
}: {
  sql: string;
  placeholder?: string;
  className?: string;
}) => {
  return (
    <Suspense fallback={<Loading />}>
      <LazySQLView
        sql={sql}
        placeholder={placeholder}
        className={classNames(
          "rounded border border-[#E8E8EE] text-[#606060] font-query text-[13px]",
          className,
        )}
      />
    </Suspense>
  );
};

export default SQLView;
